import { constants } from '@tock/shared-app-constants';

// Can't namespace by file, so just dump everything here to avoid redundant names
const ClowncarAppConstants = constants([
  'ACCOLADE_TYPE_FETCH',
  'ACCOLADE_TYPE_INSERT',
  'ACCOLADE_TYPE_DELETE',
  'ACCOLADE_TYPE_UPDATE',
  'ACCOLADE_TYPE_RATING_FETCH',
  'ACCOLADE_TYPE_RATING_INSERT',
  'ACCOLADE_TYPE_RATING_DELETE',
  'ACCOLADE_TYPE_RATING_UPDATE',
  'ADMIN_ACCOUNT_CREATE',
  'BANK_ACCOUNT_CHANGE',
  'BANK_ACCOUNT_FETCH',
  'BANK_TRANSFER_APPROVE',
  'BANK_TRANSFER_FETCH',
  'BANK_TRANSFER_START',
  'BUSINESS_CREATE',
  'BUSINESS_FETCH',
  'BUSINESS_SET',
  'BUSINESS_SHOW',
  'BUSINESS_TOCK_PRODUCT_TYPE_LEVEL_UPDATE',
  'BUSINESS_TYPE_UPDATE',
  'BUSINESSES_FETCH',
  'BUSINESSES_FETCH_EXPORT_ENVIRONMENT',
  'BUSINESSES_FETCH_IMPORT_ENVIRONMENT',
  'BUSINESS_GROUP_CREATE',
  'BUSINESS_GROUPS_FETCH',
  'BUSINESS_GROUP_FETCH',
  'BUSINESS_GROUP_UPDATE',
  'BUSINESS_GROUP_UPDATE_IMAGE',
  'BUSINESSES_SEARCH_ATTRIBUTE_FETCH',
  'BUSINESSES_SEARCH_ATTRIBUTE_INSERT',
  'BUSINESSES_SEARCH_ATTRIBUTE_UPDATE',
  'BUSINESSES_SEARCH_SET',
  'BUSINESSES_SET_FILTER_GUEST_MARKETING',
  'BUSINESSES_UPDATE_GUEST_MARKETING',
  'CLEAR_TOS',
  'CONFIGURATION_PUSH',
  'CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_GET_ALL',
  'CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_INSERT',
  'CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_PUT',
  'CONSUMER_PAGE_COLLECTION_DATA_CONFIGS_REMOVE',
  'CONSUMER_PAGE_CONFIG_DRAFT_GET_ALL',
  'CONSUMER_PAGE_CONFIG_DRAFT_GET',
  'CONSUMER_PAGE_CONFIG_GET',
  'CONSUMER_PAGE_CONFIG_GET_BY_DRAFT',
  'CONSUMER_PAGE_CONFIG_INSERT',
  'CONSUMER_PAGE_CONFIG_SELECT',
  'CONSUMER_PAGE_CONFIG_CLEAR',
  'CONSUMER_PAGE_CONFIG_DRAFT_UPDATE',
  'CONSUMER_PAGE_CONFIG_UPDATE',
  'CONSUMER_PAGE_CONFIG_DELETE',
  'CONSUMER_PAGE_NAMED_CONFIGS_GET_ALL',
  'CONSUMER_PAGE_NAMED_CONFIGS_INSERT',
  'CONSUMER_PAGE_NAMED_CONFIGS_PUT',
  'CONSUMER_PAGE_NAMED_CONFIGS_REMOVE',
  'CUSTOM_TOS_UPLOAD',
  'DASHBOARD_STATS_FETCH_ALL',
  'DISPUTES_ADD',
  'DOMAIN_CHECK',
  'FEATURES_FETCH',
  'FEATURE_BUSINESS_FETCH',
  'FEATURE_BUSINESS_CREATE',
  'FEATURE_BUSINESS_UPDATE',
  'FEATURE_CREATE',
  'FEATURE_DELETE',
  'FEATURE_UPDATE',
  'GIFT_RESEND_REDEEM_EMAIL',
  'IMPORT_FETCH_TICKET_TYPES',
  'IMPORT_UPLOAD',
  'IMPORT_WORKFLOW_CREATED',
  'IMPORT_REPORT_VALIDATE_FILE',
  'INVOICE_REFUND',
  'PRE_IMPORT_REPORT_GENERATE',
  'POST_IMPORT_REPORT_GENERATE',
  'INTERNAL_ACCOUNT_DELETE',
  'INTERNAL_ACCOUNT_STATUS_UPDATE',
  'INTERNAL_BUSINESS_DETAILS_UPDATE',
  'INTERNAL_GLOBAL_TEXTING_UNSUBSCRIBE',
  'INTERNAL_PAYOUT_CONFIG_CHANGE',
  'MENU_MIGRATOR_EXPORT',
  'MENU_MIGRATOR_IMPORT',
  'METRO_AREA_GET_ALL',
  'METRO_AREA_INSERT',
  'METRO_AREA_SELECT',
  'METRO_AREA_UPDATE',
  'METRO_AREA_UPDATE_IMAGE',
  'ONBOARDING_ACTIVATE',
  'ONBOARDING_ACTIVATION_WARNINGS',
  'ONBOARDING_CREATE',
  'ONBOARDING_DEACTIVATE',
  'ONBOARDING_SALESFORCE_GET_BUSINESS',
  'ONBOARDING_SALESFORCE_CREATE_BUSINESS',
  'ONBOARDING_SALESFORCE_GET_BUSINESS',
  'ONBOARDING_SCHEDULE_DEACTIVATION',
  'ONBOARDING_CANCEL_SCHEDULE_DEACTIVATION',
  'ONBOARDING_INVITE',
  'ONBOARDING_FETCH_ALL',
  'ONBOARDING_REMOVE',
  'ONBOARDING_RESEND_INVITE',
  'PARTNER_FETCH_ALL',
  'PARTNER_INSERT',
  'PHONE_NUMBER_GET_ALL',
  'PHONE_NUMBER_INSERT',
  'PHONE_NUMBER_SELECT',
  'PHONE_NUMBER_UPDATE',
  'SCHEDULE_HISTORY_FETCH_LIST',
  'SCHEDULE_HISTORY_FETCH_DETAIL',
  'SUBSCRIPTION_ADDON_ADD',
  'SUBSCRIPTION_ARCHIVE',
  'SUBSCRIPTION_DEACTIVATED_SUBSCRIPTION_END_CHANGED',
  'SUBSCRIPTION_DELETE',
  'SUBSCRIPTION_PLAN_ADD',
  'SUBSCRIPTION_PLAN_ADDONS_FETCH',
  'SUBSCRIPTION_PLANS_FETCH',
  'SUBSCRIPTION_SCHEDULE_CHANGE',
  'SUBSCRIPTION_SCHEDULED_CHANGE_REMOVED',
  'SUBSCRIPTION_UPDATE',
  'SUBSCRIPTIONS_FETCH',
  'SUBSCRIPTION_PLAN_ADD',
  'UPDATE_PAYMENT_PROCESSOR_TO_BRAINTREE',
  'SSO_LOGIN_TOKEN_FETCH',
  'TOCK_GIFT_CARD_BULK_PURCHASE',
  'FETCH_EVENTS',
  'FETCH_BASE_STATE',

  // Logsearch.
  'LOGSEARCH',

  'PATRON_RESET_FAILED_LOGIN_ATTEMPTS',
  'PATRONS_SEARCH',

  'VALIDATE_PHONE_REQUEST',

  'VERIFICATIONS_REQUIRED',
  'VERIFICATION_ACCEPT_EVIDENCE',
  'VERIFICATION_EVIDENCE_UPLOAD',

  'AJAX',

  // Do nothing action
  'NULL',
]);

export default ClowncarAppConstants;
